export enum RattachementUserPatrimoinePathEnum {
  userPatrimoines = 'user-patrimoines',
  patrimoineUsers = 'patrimoine-users'
}
